<template>
    <div>
        <Collapse v-model="activeIndex" @on-change="getIndex" v-if="isbool">
            <Panel :name="(index+1)+''" v-for="(item,index) in historyArr" :key="index">
                 {{item.beginDate}} ~ {{item.endDate}} {{"- " + item.priceName}}
                <div slot="content" style="margin:-16px;" v-if="item.agreementDetail">
                    <Row class="detail-header">
                        <span>结算规则</span>
                    </Row>
                    <Row class="detail-content">
                        <Row class="detail-form-block">
                            <Row class="detail-form-item">
                                <Row class="block-header">代理费</Row>
                                <Row class="block-content">
                                    <Row><Col span="5" class="left-label">有无代理费：</Col><Col span="16" class="right-content">{{item.agreementDetail.agentFee?"有":"无"}}</Col></Row>
                                    <Row v-if="item.agreementDetail?agreementDetail.agentFee:false"><Col span="5" class="left-label">代理费金额：</Col><Col span="16" class="right-content">{{common.formateNumber(item.agreementDetail.agentFee||"")}}</Col></Row>
                                </Row>
                            </Row>
                            <Row class="detail-form-item">
                                <Row class="block-header">分成比例</Row>
                                <Row class="block-content block-info-content">
                                    <Row class="block-content-title">
                                        <Row>
                                            <div class="title-begin">金额下限</div>
                                            <div class="title-end">金额上限</div>
                                            <div class="title-proportion">比例</div>
                                        </Row>
                                    </Row>
                                    <Row v-for="(itemRatio,indexRatio) in item.agreementDetail.ratioList" :label-width="0" :key="indexRatio">
                                        <Row class="fee-loop-list">
                                            <Row class="fee-loop-content">
                                                <div class="fee-loop-begin">
                                                    {{common.formateNumber(itemRatio.minAmount)}}
                                                </div>
                                                <div class="fee-loop-end">
                                                    {{itemRatio.maxAmount?common.formateNumber(itemRatio.maxAmount):"无"}}
                                                </div>
                                                <div class="fee-loop-proportion">
                                                    {{`${itemRatio.ratio}%`}}
                                                </div>
                                            </Row>
                                        </Row>
                                    </Row>
                                </Row>
                            </Row>
                            <Row class="detail-form-item">
                                <Row class="block-header">奖励费用</Row>
                                <Row class="block-content block-info-content">
                                    <Row class="block-content-title">
                                        <Row>
                                            <div class="title-select">条件</div>
                                            <div class="title-select-fee">奖励</div>
                                        </Row>
                                    </Row>
                                    <Row v-for="(itemList,indexList) in fillterArr(item.agreementDetail.additionalFeeList,'R')" :label-width="0" :key="indexList">
                                        <Row class="fee-loop-list">
                                            <Row class="fee-loop-content">
                                                <div class="fee-loop-select">
                                                    {{itemList.feeItemName || ""}}
                                                </div>
                                                <div class="fee-loop-select-prencent">
                                                    {{itemList.ratio?`${itemList.ratio}%`:common.formateNumber(itemList.fixedAmount || "")}}
                                                </div>
                                            </Row>
                                        </Row>
                                    </Row>
                                </Row>
                            </Row>
                            <Row class="detail-form-item">
                                <Row class="block-header">附加管理费用</Row>
                                <Row class="block-content block-info-content">
                                    <Row class="block-content-title">
                                        <Row>
                                            <div class="title-select">条件</div>
                                            <div class="title-select-fee">附加费</div>
                                        </Row>
                                    </Row>
                                    <Row v-for="(itemList,indexList) in fillterArr(item.agreementDetail.additionalFeeList,'S')" :label-width="0" :key="indexList">
                                        <Row class="fee-loop-list">
                                            <Row class="fee-loop-content">
                                                <div class="fee-loop-select">
                                                    {{itemList.feeItemName || ""}}
                                                </div>
                                                <div class="fee-loop-select-prencent">
                                                    {{itemList.ratio?`${itemList.ratio}%`:common.formateNumber(itemList.fixedAmount || "")}}
                                                </div>
                                            </Row>
                                        </Row>
                                    </Row>
                                </Row>
                            </Row>
                            <Row class="detail-form-item">
                                <Row class="block-header">安盾终止补偿</Row>
                                <Row class="block-content">
                                    <Row><Col span="5" class="left-label">安盾终止—立案前：</Col><Col span="16" class="right-content">{{common.formateNumber(item.agreementDetail.terminationCaseBeforeAmount || "")}}</Col></Row>
                                    <Row>
                                        <Col span="5" class="left-label">安盾终止—立案后：</Col>
                                        <Col span="16" class="right-content">
                                            {{item.agreementDetail.terminationCaseAfterRatio?`${item.agreementDetail.terminationCaseAfterRatio}%`:common.formateNumber(item.agreementDetail.terminationCaseAfterFixedAmount || "")}}
                                        </Col>
                                    </Row>
                                </Row>
                            </Row>
                        </Row>
                    </Row>
                </div>
            </Panel>
        </Collapse>
    </div>
</template>
<script>
export default {
    data () {
        return {
            historyArr:[],
            isbool:false,
            activeIndex:["1"],
            agreementDetail:{}
        }
    },
    props: ['id'],
    methods: {
        getData(){
            let url = `/settlement/agreement-price-lawyers/${this.id}/correlation`;
            this.$get(url).then(res=>{
                this.isbool = true;
                if(res.code==0){
                    this.agreementDetail = res.data || {};
                    this.historyArr = res.data.relationPriceList;
                    this.historyArr.forEach((item,index)=>{
                        item.agreementDetail = index==0?this.agreementDetail:{};
                    })
                }else{
                    this.$Message.error(res.message);
                }
            })
        },
        getIndex(arr){
            arr.forEach((item,index)=>{
                let num = Number(item)-1;
                if(Object.keys(this.historyArr[num].agreementDetail).length==0){
                    this.getLawyerDetail(this.historyArr[num].priceId,num);
                }
            })
        },
        getLawyerDetail(id,index){
            let url = '/settlement/agreement-price-lawyers/'+id;
            this.$get(url).then(res=>{
                if(res.code==0){
                    this.historyArr[index].agreementDetail = res.data;
                    this.$set(this.historyArr,index,this.historyArr[index]);
                }
            })
        },
        fillterArr(arr,type){
            if(!arr){return []}
            return this.agreementDetail.additionalFeeList.filter((item,index)=>{
                return item.feeType==type
            })
        }
    },
    created(){},
    beforeMount(){
        this.getData();
    },
    mounted(){},
    updated(){},
    computed:{},
    components: {},
    watch: {}
}
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/view/taskHall/plugin/taskLawyerPriceInfo/index.vue